import React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import QRCodeImage from '../../assets/images/canam-qr.png';
import AffiliateAboutBanner from '../../assets/images/trees_canam.jpg';
import RoutePaths from '../../configs/Routes';

const ReadyToStartEarning = () => (
  <Box
    sx={{
      position: 'relative',
      backgroundImage: `url(${AffiliateAboutBanner})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      py: { xs: 5, md: 10 },
      px: 2,
      textAlign: 'center',
      color: '#fff',
      overflow: 'hidden',
    }}
  >
    {/* Black Transparent Overlay */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 1,
      }}
    />

    {/* Content */}
    <Box sx={{ position: 'relative', zIndex: 2, maxWidth: '1200px', mx: 'auto', px: { xs: 2, sm: 4, md: 8 } }}>
      <Grid container spacing={4} justifyContent="center" alignItems="center">
        {/* Left Column */}
        <Grid item xs={12} md={4}>
          <Typography
            fontFamily='"Archivo Black", sans-serif'
            fontWeight={900}
            variant="h4"
            color="#FFFFFF"
            gutterBottom
          >
            Ready to Start <br /> Earning?
          </Typography>
          <Typography variant="body1" mt={2}>
            Whether you meet one tourist or hundreds — turn those connections into cash with CanAm.
          </Typography>
        </Grid>

        {/* Center QR Code */}
        <Grid item xs={12} md={4}>
          <Box
            component="img"
            src={QRCodeImage}
            alt="QR Code"
            sx={{
              maxWidth: 200,
              width: '100%',
              mx: 'auto',
              borderRadius: 2,
              backgroundColor: '#fff',
            }}
          />
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={4}>
          <Typography
            fontFamily='"Archivo Black", sans-serif'
            fontWeight={900}
            variant="h4"
            color="#FFFFFF"
          >
            Join Free in Under <br /> 5 Minutes!
          </Typography>
          <Typography variant="body1" mt={2}>
            Scan the QR code or click the button below to get started.
          </Typography>
        </Grid>

        {/* CTA Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            size="large"
            sx={{
              mt: 3,
              backgroundColor: '#00B3FF',
              color: '#fff',
              borderRadius: '999px',
              px: 8,
              py: 2,
              '&:hover': {
                backgroundColor: '#0095D5',
              },
              fontFamily: 'Lato',
              fontWeight: '700',
              lineHeight: '100%',
              letterSpacing: '0%',
            }}
            LinkComponent={Link}
            to={RoutePaths.SIGN_UP}
          >
            Sign Up Free
          </Button>
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default ReadyToStartEarning;
